/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAggregatedTimerecordBalanceDto } from '../models/work-aggregated-timerecord-balance-dto';
import { WorkTimerecordBalance } from '../models/work-timerecord-balance';
import { WorkTimerecordBalancesByYearMonthAndUserIdDto } from '../models/work-timerecord-balances-by-year-month-and-user-id-dto';
import { WorkTimerecordSaldoDto } from '../models/work-timerecord-saldo-dto';
import { WorkUpdateTimerecordBalanceDto } from '../models/work-update-timerecord-balance-dto';

@Injectable({ providedIn: 'root' })
export class WorkTimerecordBalancesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timerecordBalancesV2ControllerFindAggregatedByUserIdAndYear()` */
  static readonly TimerecordBalancesV2ControllerFindAggregatedByUserIdAndYearPath = '/v2/timerecord-balances/aggregated/byUserId/{userId}/{year}';

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordBalancesV2ControllerFindAggregatedByUserIdAndYear()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordBalancesV2ControllerFindAggregatedByUserIdAndYear$Response(
    params: {
      userId: number;
      year: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAggregatedTimerecordBalanceDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordBalancesV2Service.TimerecordBalancesV2ControllerFindAggregatedByUserIdAndYearPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('year', params.year, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAggregatedTimerecordBalanceDto>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordBalancesV2ControllerFindAggregatedByUserIdAndYear$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordBalancesV2ControllerFindAggregatedByUserIdAndYear(
    params: {
      userId: number;
      year: number;
    },
    context?: HttpContext
  ): Observable<WorkAggregatedTimerecordBalanceDto> {
    return this.timerecordBalancesV2ControllerFindAggregatedByUserIdAndYear$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAggregatedTimerecordBalanceDto>): WorkAggregatedTimerecordBalanceDto => r.body)
    );
  }

  /** Path part for operation `timerecordBalancesV2ControllerFindByYearAndUserId()` */
  static readonly TimerecordBalancesV2ControllerFindByYearAndUserIdPath = '/v2/timerecord-balances/byYearAndUserId/{year}/{userId}';

  /**
   * Required permissions: timerecordbalances:read, timerecordbalances:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordBalancesV2ControllerFindByYearAndUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordBalancesV2ControllerFindByYearAndUserId$Response(
    params: {
      year: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecordBalance>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordBalancesV2Service.TimerecordBalancesV2ControllerFindByYearAndUserIdPath, 'get');
    if (params) {
      rb.path('year', params.year, {});
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecordBalance>;
      })
    );
  }

  /**
   * Required permissions: timerecordbalances:read, timerecordbalances:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordBalancesV2ControllerFindByYearAndUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordBalancesV2ControllerFindByYearAndUserId(
    params: {
      year: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<WorkTimerecordBalance> {
    return this.timerecordBalancesV2ControllerFindByYearAndUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecordBalance>): WorkTimerecordBalance => r.body)
    );
  }

  /** Path part for operation `timerecordBalancesV2ControllerUpdate()` */
  static readonly TimerecordBalancesV2ControllerUpdatePath = '/v2/timerecord-balances/{id}';

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordBalancesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecordBalancesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTimerecordBalanceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecordBalance>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordBalancesV2Service.TimerecordBalancesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecordBalance>;
      })
    );
  }

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordBalancesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecordBalancesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTimerecordBalanceDto
    },
    context?: HttpContext
  ): Observable<WorkTimerecordBalance> {
    return this.timerecordBalancesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecordBalance>): WorkTimerecordBalance => r.body)
    );
  }

  /** Path part for operation `timerecordBalancesV2ControllerFindSaldoByUserIdAndDate()` */
  static readonly TimerecordBalancesV2ControllerFindSaldoByUserIdAndDatePath = '/v2/timerecord-balances/saldo/byUserId/{userId}/{date}';

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordBalancesV2ControllerFindSaldoByUserIdAndDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordBalancesV2ControllerFindSaldoByUserIdAndDate$Response(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecordSaldoDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordBalancesV2Service.TimerecordBalancesV2ControllerFindSaldoByUserIdAndDatePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('date', params.date, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecordSaldoDto>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordBalancesV2ControllerFindSaldoByUserIdAndDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordBalancesV2ControllerFindSaldoByUserIdAndDate(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<WorkTimerecordSaldoDto> {
    return this.timerecordBalancesV2ControllerFindSaldoByUserIdAndDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecordSaldoDto>): WorkTimerecordSaldoDto => r.body)
    );
  }

  /** Path part for operation `timerecordBalancesV2ControllerFindAggregatedTimerecordBalancesByYearMonth()` */
  static readonly TimerecordBalancesV2ControllerFindAggregatedTimerecordBalancesByYearMonthPath = '/v2/timerecord-balances/aggregated-timerecord-balances/{year}/{month}/{userId}';

  /**
   * Required permissions: timerecords:read, timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordBalancesV2ControllerFindAggregatedTimerecordBalancesByYearMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordBalancesV2ControllerFindAggregatedTimerecordBalancesByYearMonth$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecordBalancesByYearMonthAndUserIdDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordBalancesV2Service.TimerecordBalancesV2ControllerFindAggregatedTimerecordBalancesByYearMonthPath, 'get');
    if (params) {
      rb.path('year', params.year, {});
      rb.path('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecordBalancesByYearMonthAndUserIdDto>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read, timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordBalancesV2ControllerFindAggregatedTimerecordBalancesByYearMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordBalancesV2ControllerFindAggregatedTimerecordBalancesByYearMonth(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkTimerecordBalancesByYearMonthAndUserIdDto> {
    return this.timerecordBalancesV2ControllerFindAggregatedTimerecordBalancesByYearMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecordBalancesByYearMonthAndUserIdDto>): WorkTimerecordBalancesByYearMonthAndUserIdDto => r.body)
    );
  }

}
